var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['form-element', _vm.hidden && 'd-none']},[(_vm.label)?_c('FormLabel',_vm._b({attrs:{"tag":"legend"}},'FormLabel',{
      label: _vm.label,
      required: _vm.required,
      disabled: _vm.disabled,
      description: _vm.description,
      descriptionType: _vm.descriptionType,
      dirty: _vm.dirty,
      error: _vm.error,
      id: _vm.id,
      status: _vm.status
    },false)):_vm._e(),(_vm.instructors && _vm.instructors.length)?_c('ul',{staticClass:"form-sy-instructors__list"},_vm._l((_vm.instructors),function(instructor){return _c('li',{key:instructor._id},[_vm._v("\n      "+_vm._s(_vm.getFullName(instructor))+"\n      "),(instructor.email)?[_vm._v(" ("+_vm._s(instructor.email)+")")]:_vm._e(),_c('AppBadge',{staticClass:"ml-2"},[_vm._v(_vm._s(instructor.type))])],2)}),0):_c('div',{staticClass:"text-muted"},[_vm._v("No instructors")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }